
























































import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class ResetPassword extends Vue {
  password = ''
  confirm = ''
  query = {}
  status = null as null | 'ok' | 'error'

  get ok() {
    return this.password.length > 6 && this.password == this.confirm
  }

  created() {
    this.query = Object.assign({}, this.$route.query)
    this.$router.replace({ query: {} })
  }

  async submit() {
    if (!this.ok) return
    console.log(this.query)
    try {
      const res = await this.$api
        .ky('password/reset/', {
          method: 'put',
          json: { ...this.query, password: this.password }
        })
        .json()
      this.status = 'ok'
    } catch {
      this.status = 'error'
    }
  }
}
